'use client'

import i18n from 'i18next'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import contact from '../../public/locales/ko/contact.json'
import fanfic from '../../public/locales/ko/fanfic.json'
import faq from '../../public/locales/ko/faq.json'
import home from '../../public/locales/ko/home.json'
import notice from '../../public/locales/ko/notice.json'
import terms from '../../public/locales/ko/terms.json'

// 정적 빌드 HTML에 본문이 구워지도록 ko는 번들에 넣고 동기 초기화한다.
// 서버 렌더와 첫 클라이언트 렌더를 ko로 맞추고, 사용자 언어 전환은 I18nProvider가 마운트 후에 한다.
if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      lng: 'ko',
      fallbackLng: 'ko',
      supportedLngs: ['en', 'ko', 'zh-CN', 'zh-TW', 'jp'],
      resources: { ko: { contact, fanfic, faq, home, notice, terms } },
      partialBundledLanguages: true,
      initAsync: false,
      interpolation: { escapeValue: false },
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json'
      },
      ns: ['home', 'notice', 'faq', 'contact', 'fanfic'],
      defaultNS: 'home'
    })
}

export default i18n
